<template>
  <div class="classDetail">
    <el-card>
      <div class="flex" style="align-items: flex-start;">
        <div class="classDetail-left">
          <div class="classDetail-search">
            <el-cascader style="width: 100%; margin-top: 20px" clearable v-model="searchForm.campusId" :show-all-levels="false" :props="campusTreeProps" placeholder="请选择所属校区" :options="campusList" @change="campusIdChange(searchForm.campusId)"></el-cascader>
            <el-cascader style="width: 100%; margin-top: 20px" clearable v-model="searchForm.subjectId" :show-all-levels="false" :props="subjectProps" placeholder="请选择所属科目" :options="ClassInfoTree" @change="subjectIdChange(searchForm.campusId)"></el-cascader>
            <el-tree :data="classInfoPhaseTree" :props="ChapterProps" :expand-on-click-node="false" class="classDetail-tree" ref="tree" node-key="id">
              <span class="span-ellipsis" slot-scope="{ node, data }" @click="handleNodeClick(data)">
                <el-tooltip :content="data.className" placement="top">
                  <span>{{ data.className }}</span>
                </el-tooltip>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="classDetail-right">
          <div class="classDetail-top">
            <el-row>
              <el-col :sm="12" :md="12" :lg="12" class="classDetail-right-top">
                <!-- {{classInfoDetail.subjectName}} -->
                <div v-if="subjectNameBlock" class="right-top-text">
                  {{ classInfoDetail.className }}
                </div>
              </el-col>
              <el-col :sm="12" :md="12" :lg="12" style="float: right">
                <div class>
                  <div v-if="classInfoDetailTrue == true" class="classDetail-icon" @click="classInfoDetailTrue = false">
                    收起
                    <i class="el-icon-arrow-up"></i>
                  </div>
                  <div v-if="classInfoDetailTrue == false" class="classDetail-icon" @click="classInfoDetailTrueChange()">
                    展开
                    <i class="el-icon-arrow-down"></i>
                  </div>
                  <!-- <i
                    class="classDetail-icon el-icon-delete"
                    @click="deleteClassInfo"
                    style="padding-top:5px"
                  ></i> -->
                  <i class="classDetail-icon el-icon-edit" @click="editClassInfo" style="padding-top: 5px"></i>
                </div>
              </el-col>
            </el-row>
            <div v-if="classInfoDetailTrue == true">
              <el-form :model="classInfoDetail" :label-width="formLabelWidth">
                <el-row>
                  <el-col :sm="8" :md="8" :lg="8">
                    <el-form-item label="所属校区:">{{
                        classInfoDetail.campusName
                    }}</el-form-item>
                  </el-col>
                  <el-col :sm="8" :md="8" :lg="8">
                    <el-form-item label="所属课程:">{{
                        classInfoDetail.subjectName
                    }}</el-form-item>
                  </el-col>
                  <el-col :sm="8" :md="8" :lg="8">
                    <el-form-item label="班主任:">{{
                        classInfoDetail.headTeacherName
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="8" :md="8" :lg="8">
                    <el-form-item label="上课时间:">{{
                        classInfoDetail.type
                    }}</el-form-item>
                  </el-col>
                  <el-col :sm="8" :md="8" :lg="8">
                    <el-form-item label="开班时间:">{{ classInfoDetail.startDate }}至{{
                        classInfoDetail.endDate
                    }}</el-form-item>
                  </el-col>
                  <el-col :sm="8" :md="8" :lg="8">
                    <el-form-item label="开班人数:">{{ classInfoDetail.minNumber }}/{{
                        classInfoDetail.maxNumber
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="8" :md="8" :lg="8">
                    <el-form-item label="签到距离:">{{
                        classInfoDetail.signDistance == -1
                          ? '无签到要求'
                          : classInfoDetail.signDistance
                    }}</el-form-item>
                  </el-col>
                  <el-col :sm="8" :md="8" :lg="8">
                    <el-form-item label="QQ群:">{{
                        classInfoDetail.qqGroup
                    }}</el-form-item>
                  </el-col>
                  <el-col :sm="8" :md="8" :lg="8">
                    <el-form-item label="68班级:">
                      <div class="classDetail-top-qrcode" id="qrcode" @click="showQrcode"></div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <el-row>
                  <el-col :sm="6" :md="6" :lg="6">
                    this.classInfoDetail.id 
                   <div @click="qrImgDialogHz = true">
                      <el-form-item label="hz班级:">
                        <qrcode
                          :value="
                            qrcodeUrl +
                            `/qrcodeHzkt/add?id=` +
                            this.classInfoDetail.id +
                            `&agentId=` +
                            this.classInfoDetail.agentId +
                            `&type=0`
                          "
                          :options="{ size: 100 }"
                        ></qrcode>
                      </el-form-item>
                    </div> 
                 </el-col>
               </el-row> -->
              </el-form>
            </div>
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="课程" name="first" class="tab-type">
              <!-- <el-button type="primary" size="small" @click="goAddClass">添加排课</el-button> -->
              <el-table ref="multipleTable" :data="classList" style="width: 100%; margin-top: 20px" border :loading="classListLoading">
                <el-table-column show-overflow-tooltip label="排班二维码" align="center" width="180">
                  <template slot-scope="scope">
                    <qrcode :value="
                      qrcodeUrl +
                      `/qrcode/add?id=` +
                      scope.row.id +
                      `&agentId=` +
                      classInfoDetail.agentId +
                      `&type=1`
                    " :options="{ size: 100 }"></qrcode>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  show-overflow-tooltip
                  label="弘智课堂"
                  align="center"
                  width="180"
                >
                  <template slot-scope="scope">
                    <qrcode
                      :value="
                        qrcodeUrl +
                        `/qrcodeHzkt/add?id=` +
                        scope.row.id +
                        `&agentId=` +
                        classInfoDetail.agentId +
                        `&type=1`
                      "
                      :options="{ size: 100 }"
                    ></qrcode>
                  </template>
                </el-table-column> -->
                <el-table-column prop="subjectCourseName" show-overflow-tooltip label="课程" align="center" width="180"></el-table-column>
                <el-table-column prop="className" show-overflow-tooltip label="班级" align="center" width="160"></el-table-column>
                <el-table-column prop="classroomName" show-overflow-tooltip label="教室" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.classroomName">{{
                        scope.row.classroomName
                    }}</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="teacherName" show-overflow-tooltip label="上课老师" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.teacherName">{{
                        scope.row.teacherName
                    }}</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="courseCount" show-overflow-tooltip label="课时" align="center">
                  <template slot-scope="scope">{{ scope.row.endCourseCount }}/{{
                      scope.row.courseCount
                  }}</template>
                </el-table-column>
                <el-table-column prop="courseCount" show-overflow-tooltip label="开课时间" align="center" width="200">
                  <template slot-scope="scope">
                    <span v-if="
                      scope.row.courseStartDate && scope.row.courseEndDate
                    ">{{ scope.row.courseStartDate }}至{{
    scope.row.courseEndDate
}}</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="studentCount" show-overflow-tooltip label="学员" align="center">
                  <template slot-scope="scope">
                    <span class="operation-style" @click="goStudent(scope.row)">{{ scope.row.studentCount }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="scheduleStateName" label="排课状态" align="center" show-overflow-tooltip width="110">
                  <template slot-scope="row">
                    <span class="courseManage style1" v-if="row.row.scheduleStateName == '已排课'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
                    <span class="courseManage style1" v-if="row.row.scheduleStateName == '开课中'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
                    <span class="courseManage style2" v-if="row.row.scheduleStateName == '未排课'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
                    <span class="courseManage style3" v-if="row.row.scheduleStateName == '已结束'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="课表" name="second" class="tab-type calendarType">
              <div style="display: flex">
                <div style="display: flex">
                  <div class="rowStyle1"></div>
                  <div class="rowStyle3-text">普通</div>
                </div>
                <div style="display: flex">
                  <div class="rowStyle2"></div>
                  <div class="rowStyle3-text">新课</div>
                </div>
                <div style="display: flex">
                  <div class="rowStyle3"></div>
                  <div class="rowStyle3-text">调课</div>
                </div>
                <div style="display: flex">
                  <div class="rowStyle4"></div>
                  <div class="rowStyle3-text">停课</div>
                </div>
                <div style="display: flex">
                  <div class="rowStyle5"></div>
                  <div class="rowStyle3-text">结课</div>
                </div>
              </div>
              <el-tabs type="card" style="margin-top: 20px" v-model="calendarActiveName" @tab-click="calendarHandleClick">
                <el-tab-pane label="周" name="week">
                  <el-button-group class="calendar-button">
                    <el-button size="small" class="calendar-button1" @click="lastWeek">上一周</el-button>
                    <el-button size="small" class="calendar-button1" @click="nowWeek">今天</el-button>
                    <el-button size="small" class="calendar-button1" @click="nextWeek">下一周</el-button>
                  </el-button-group>
                  <el-calendar :range="currentWeekDate">
                    <template slot="dateCell" slot-scope="{ date, data }">
                      <div :class="data.isSelected ? 'is-selected' : ''">
                        {{ data.day.split('-').slice(2).join('-') }}
                      </div>
                      <div v-for="(item, index) in calendarData" :key="index">
                        <div v-if="
                          item.date
                            .split('-')[1]
                            .indexOf(data.day.split('-').slice(1)[0]) != -1
                        ">
                          <div v-if="
                            item.date
                              .split('-')[2]
                              .indexOf(
                                data.day.split('-').slice(2).join('-')
                              ) != -1
                          ">
                            <div v-for="(items, indexs) in item.data" :key="indexs">
                              <el-tooltip class="item" effect="light" placement="right">
                                <div slot="content">
                                  <div class="calendar-solt1">
                                    {{
                                        items.subjectCourse.name +
                                        '-第' +
                                        items.sequence +
                                        '课时'
                                    }}
                                  </div>
                                  <div class="calendar-solt2">
                                    上课时间:{{
                                        items.schedulePeriod.beginTime
                                    }}-{{ items.schedulePeriod.endTime }}
                                  </div>
                                  <div class="calendar-solt2">
                                    上课老师:{{ items.teacher.name }}
                                  </div>
                                  <div class="calendar-solt2">
                                    上课教室:{{ items.classroom.name }}
                                  </div>
                                  <div class="calendar-solt3"></div>
                                  <div style="float: right">
                                    <el-button v-if="
                                      items.courseState !== 4 &&
                                      items.courseState !== 2
                                    " type="text" @click="changingCourse(items)">调课</el-button>
                                    <el-button v-if="
                                      items.courseState !== 4 &&
                                      items.courseState !== 2
                                    " type="text" @click="suspendClass(items)">停课</el-button>
                                    <el-button v-if="items.courseState === 4" type="text" @click="resumeClass(items)">复课</el-button>
                                  </div>
                                </div>
                                <div v-if="items.courseState === -1" class="classDetail-study0" type="size">
                                  <div>
                                    {{ items.classInfo.name }}-{{
                                        items.subjectCourse.name
                                    }}
                                  </div>
                                </div>
                                <div v-if="items.courseState === 1" class="classDetail-study1" type="size">
                                  <div>
                                    {{ items.classInfo.name }}-{{
                                        items.subjectCourse.name
                                    }}
                                  </div>
                                </div>
                                <div v-if="items.courseState === 2" class="classDetail-study4" type="size">
                                  <div>
                                    {{ items.classInfo.name }}-{{
                                        items.subjectCourse.name
                                    }}
                                  </div>
                                </div>
                                <div v-if="items.courseState === 3" class="classDetail-study2" type="size">
                                  <div>
                                    {{ items.classInfo.name }}-{{
                                        items.subjectCourse.name
                                    }}
                                  </div>
                                </div>
                                <div v-if="items.courseState === 4" class="classDetail-study3" type="size">
                                  <div>
                                    {{ items.classInfo.name }}-{{
                                        items.subjectCourse.name
                                    }}
                                  </div>
                                </div>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-calendar>
                </el-tab-pane>
                <el-tab-pane label="月" name="month">
                  <el-calendar v-model="currentDate">
                    <template slot="dateCell" slot-scope="{ date, data }">
                      <div :class="data.isSelected ? 'is-selected' : ''">
                        {{ data.day.split('-').slice(2).join('-') }}
                      </div>
                      <div v-for="(item, index) in calendarData" :key="index">
                        <div v-if="
                          item.date
                            .split('-')[1]
                            .indexOf(data.day.split('-').slice(1)[0]) != -1
                        ">
                          <div v-if="
                            item.date
                              .split('-')[2]
                              .indexOf(
                                data.day.split('-').slice(2).join('-')
                              ) != -1
                          ">
                            <div v-for="(items, indexs) in item.data" :key="indexs">
                              <el-tooltip class="item" effect="light" placement="right">
                                <div slot="content">
                                  <div class="calendar-solt1">
                                    {{
                                        items.subjectCourse.name +
                                        '-第' +
                                        items.sequence +
                                        '课时'
                                    }}
                                  </div>
                                  <div class="calendar-solt2">
                                    上课时间:{{
                                        items.schedulePeriod.beginTime
                                    }}-{{ items.schedulePeriod.endTime }}
                                  </div>
                                  <div class="calendar-solt2">
                                    上课老师:{{ items.teacher.name }}
                                  </div>
                                  <div class="calendar-solt2">
                                    上课教室:{{ items.classroom.name }}
                                  </div>
                                  <div class="calendar-solt3"></div>
                                  <div style="float: right">
                                    <el-button v-if="
                                      items.courseState !== 4 &&
                                      items.courseState !== 2
                                    " type="text" @click="changingCourse(items)">调课</el-button>
                                    <el-button v-if="
                                      items.courseState !== 4 &&
                                      items.courseState !== 2
                                    " type="text" @click="suspendClass(items)">停课</el-button>
                                    <el-button v-if="items.courseState === 4" type="text" @click="resumeClass(items)">复课</el-button>
                                  </div>
                                </div>
                                <div v-if="items.courseState === -1" class="classDetail-study0" type="size">
                                  <div>
                                    {{ items.classInfo.name }}-{{
                                        items.subjectCourse.name
                                    }}
                                  </div>
                                </div>
                                <div v-if="items.courseState === 1" class="classDetail-study1" type="size">
                                  <div>
                                    {{ items.classInfo.name }}-{{
                                        items.subjectCourse.name
                                    }}
                                  </div>
                                </div>
                                <div v-if="items.courseState === 2" class="classDetail-study4" type="size">
                                  <div>
                                    {{ items.classInfo.name }}-{{
                                        items.subjectCourse.name
                                    }}
                                  </div>
                                </div>
                                <div v-if="items.courseState === 3" class="classDetail-study2" type="size">
                                  <div>
                                    {{ items.classInfo.name }}-{{
                                        items.subjectCourse.name
                                    }}
                                  </div>
                                </div>
                                <div v-if="items.courseState === 4" class="classDetail-study3" type="size">
                                  <div>
                                    {{ items.classInfo.name }}-{{
                                        items.subjectCourse.name
                                    }}
                                  </div>
                                </div>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-calendar>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <el-dialog title="添加班级" :visible.sync="classDialogVisible" width="50%">
        <el-form ref="addForm" :model="addForm" label-width="80px" :rules="addFormRules">
          <el-row>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="所属校区" prop="campusId">
                <el-cascader style="width: 100%" clearable v-model="addForm.campusId" :show-all-levels="false" :props="campusListProps" placeholder="请选择所属校区" :options="campusList" @change="getTeacherTreeChange(addForm.campusId)"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="班级类型" prop="type">
                <el-select placeholder="请选择班级类型" style="width: 100%" v-model="addForm.type">
                  <el-option value="平时白班">平时白班</el-option>
                  <el-option value="周末白班">周末白班</el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="所属科目" prop="subjectCourseId">
                <el-cascader style="width: 100%" clearable v-model="addForm.subjectCourseId" :show-all-levels="false" :props="subjectTreeProps" placeholder="请选择所属科目" :options="subjectTreeList" @change="subjectSearchChange"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="班主任" prop="headTeacher">
                <el-select placeholder="请选择班主任" style="width: 100%" v-model="addForm.headTeacher">
                  <el-option v-for="item in headTeacherList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="班级期数" prop="classInfoPhase">
                <el-input v-model="addForm.classInfoPhase" :disabled="true"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="签到距离" prop="signDistance">
                <el-select placeholder="请选择签到距离" style="width: 100%" v-model="addForm.signDistance">
                  <el-option value="500">500米</el-option>
                  <el-option value="1000">1000米</el-option>
                  <el-option value="无签到要求">无签到要求</el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="开班人数" prop="maxNumber">
                <el-col :span="11">
                  <el-input type="number" v-model="addForm.minNumber" placeholder="请输入最低人数" maxlength="5"></el-input>
                </el-col>
                <el-col class="line" style="text-align: center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input type="number" v-model="addForm.maxNumber" placeholder="请输入最高人数" maxlength="5"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="QQ群" prop="qqGroup">
                <el-input v-model="addForm.qqGroup" placeholder="请输入QQ群" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="开班时间" prop="period">
                <el-date-picker style="width: 100%" v-model="addForm.period" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="classDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addClassInfo">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="编辑班级" :visible.sync="editClassDialogVisible" width="50%">
        <el-form ref="editForm" :model="editForm" label-width="80px" :rules="addFormRules">
          <el-row>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="所属校区" prop="campusId">
                <el-cascader style="width: 100%" clearable v-model="editForm.campusId" :show-all-levels="false" :props="campusListProps" placeholder="请选择所属校区" :options="campusList" @change="getTeacherTreeChange(editForm.campusId)"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="班级名称" prop="name">
                <el-input placeholder="请输入班级名称" v-model="editForm.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="所属科目" prop="subjectCourseId">
                <el-cascader style="width: 100%" clearable v-model="editForm.subjectCourseId" :show-all-levels="false" :props="subjectTreeProps" placeholder="请选择所属科目" :options="subjectTreeList" @change="editSubjectSearchChange"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="上班时间" prop="type">
                <el-select placeholder="请选择班级类型" style="width: 100%" v-model="editForm.type">
                  <el-option value="平时白班">平时白班</el-option>
                  <el-option value="平时晚班">平时晚班</el-option>
                  <el-option value="周末白班">周末白班</el-option>
                  <el-option value="周末晚班">周末晚班</el-option>
                  <el-option value="一三白班">一三白班</el-option>
                  <el-option value="一三晚班">一三晚班</el-option>
                  <el-option value="三五白班">三五白班</el-option>
                  <el-option value="三五晚班">三五晚班</el-option>
                  <el-option value="一三五白班">一三五白班</el-option>
                  <el-option value="一三五晚班">一三五晚班</el-option>
                  <el-option value="一四白班">一四白班</el-option>
                  <el-option value="一四晚班">一四晚班</el-option>
                  <el-option value="二四白班">二四白班</el-option>
                  <el-option value="二四晚班">二四晚班</el-option>
                  <el-option value="一二四五六日晚班">一二四五六日晚班</el-option>
                  <el-option value="周六班">周六班</el-option>
                  <el-option value="周日班">周日班</el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="班主任" prop="headTeacherName">
                <el-autocomplete class="inline-input" style="width: 100%" v-model="editForm.headTeacherName" :fetch-suggestions="querySearch" placeholder="请选择班主任" @select="handleSelect" clearable></el-autocomplete>
                <!-- <el-select placeholder="请选择班主任" style="width:100%" v-model="editForm.headTeacher">
                  <el-option v-for="item in headTeacherList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="签到距离" prop="signDistance">
                <el-select placeholder="请选择签到距离" style="width: 100%" v-model="editForm.signDistance">
                  <el-option value="500">500米</el-option>
                  <el-option value="1000">1000米</el-option>
                  <el-option value="无签到要求">无签到要求</el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="开班人数" prop="maxNumber">
                <el-col :span="11">
                  <el-input type="number" v-model="editForm.minNumber" placeholder="请输入最低人数" maxlength="5"></el-input>
                </el-col>
                <el-col class="line" style="text-align: center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input type="number" v-model="editForm.maxNumber" placeholder="请输入最高人数" maxlength="5"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="开班时间" prop="period">
                <el-date-picker style="width: 100%" v-model="editForm.period" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="12">
              <el-form-item label="QQ群" prop="qqGroup">
                <el-input v-model="editForm.qqGroup" placeholder="请输入QQ群" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editClassDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateClassInfo">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="添加学员" :visible.sync="studentDialogVisible" :close-on-click-modal="false" width="60%">
        <el-form :model="studentSearch" label-width="0px">
          <el-row :gutter="20">
            <el-col :sm="24" :md="6" :lg="6">
              <el-cascader style="width: 100%" clearable v-model="studentAllSearch.campusIds" :show-all-levels="false" :props="campusTreeProp" placeholder="请选择所属校区" :options="campusList"></el-cascader>
            </el-col>
            <el-col :sm="24" :md="6" :lg="6">
              <el-cascader style="width: 100%" clearable v-model="studentAllSearch.courseIds" :show-all-levels="false" :props="subjectTreeProps" placeholder="请选择所属科目" :options="subjectTreeList"></el-cascader>
            </el-col>
            <el-col :sm="24" :md="6" :lg="6">
              <el-input clearable v-model="studentAllSearch.name" placeholder="学员姓名/手机号" auto-complete="off" maxlength="100"></el-input>
            </el-col>
            <el-col :sm="24" :md="6" :lg="6">
              <el-date-picker style="width: 100%" v-model="studentAllSearch.period" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-col>
          </el-row>
          <el-row style="margin-top: 10px" :gutter="20">
            <el-col :sm="24" :md="6" :lg="6" style="float: right">
              <el-button type="primary" class="classRoomButton" style="float: right" @click="addClassInfoOrderInfo()">添加</el-button>
              <el-button type="primary" class="classRoomButton" style="float: left" @click="studentAllPageList()">查询</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table ref="multipleTable" :data="studentAllList.records" style="width: 100%; margin-top: 10px" row-key="id" border @selection-change="studentAllSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="状态" width="100" show-overflow-tooltip>
            <template slot-scope="row">
              <span class="courseManage style1" v-if="row.row.scheduleStateName == '已排课'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
              <span class="courseManage style1" v-if="row.row.scheduleStateName == '开课中'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
              <span class="courseManage style2" v-if="row.row.scheduleStateName == '未排课'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
              <span class="courseManage style3" v-if="row.row.scheduleStateName == '已结束'" @click="goAddClass(row.row)">{{ row.row.scheduleStateName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="campusName" label="报名校区" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="studentName" label="学员姓名" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="mobile" label="学员电话" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="报名时间" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="courseName" show-overflow-tooltip label="报名课程"></el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next, jumper,  total, sizes" style="margin-top: 20px; text-align: left" :total="studentAllList.total" :page-size="studentAllList.pageSize" :page-sizes="[10, 20, 30, 40]" :current-page="studentAllList.pageNumber" @size-change="studentAllSizeChange" @current-change="studentAllCurrentChange"></el-pagination>
      </el-dialog>

      <el-dialog class="addDialog" title="转班" width="400px" :visible.sync="changeClassDialog">
        <el-form :model="changeClassForm" status-icon ref="changeClassForm" label-width="80px" class="demo-ruleForm" :rules="changeClassFormRules">
          <el-form-item label="所属校区" prop="campusId">
            <el-cascader style="width: 100%" clearable v-model="changeClassForm.campusId" :show-all-levels="false" :props="campusListProps" placeholder="请选择所属校区" :options="campusList" @change="changeGetClassInfo(changeClassForm.campusId)"></el-cascader>
          </el-form-item>
          <el-form-item label="所属科目" prop="courseId">
            <el-cascader style="width: 100%" class="research-select" clearable v-model="changeClassForm.courseId" :show-all-levels="false" :props="subjectTreeProps" placeholder="请输入所属科目" :options="subjectTreeList" @change="subjectSearchChange"></el-cascader>
          </el-form-item>
          <el-form-item label="所属班级" prop="classInfoId">
            <el-select placeholder="请选择上课教室" style="width: 100%" v-model="changeClassForm.classInfoId" clearable>
              <el-option v-for="item in classInfoList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="text-align: right">
            <el-button @click="changeClassDialog = false">取消</el-button>
            <el-button type="primary" @click="transferClassInfo">提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog class="addDialog" title="调课" width="400px" :visible.sync="changeCourseDialog">
        <el-form :model="changeCourseForm" status-icon ref="addForm" label-width="80px" class="demo-ruleForm">
          <el-form-item label="上课教室" prop="campusId">
            <el-select placeholder="请选择上课教室" style="width: 100%" v-model="changeCourseForm.classroomId" clearable>
              <el-option v-for="item in classroomList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上课老师" prop="name">
            <el-select placeholder="请选择上课老师" style="width: 100%" v-model="changeCourseForm.teacherId" clearable>
              <el-option v-for="item in teacherList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="上课日期" prop="date">
            <el-date-picker style="width: 100%" v-model="changeCourseForm.date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="上课时间" prop="address">
            <el-row>
              <el-col :span="11">
                <el-time-select style="width: 100%" placeholder="起始时间" v-model="changeCourseForm.beginTime" :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '24:00',
                }"></el-time-select>
              </el-col>
              <el-col :span="2">
                <div class="time-selectType">至</div>
              </el-col>
              <el-col :span="11">
                <el-time-select style="width: 100%" placeholder="结束时间" v-model="changeCourseForm.endTime" :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '24:00',
                  minTime: changeCourseForm.beginTime,
                }"></el-time-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item style="text-align: right">
            <el-button @click="changeCourseDialog = false">取消</el-button>
            <el-button type="primary" @click="transferClass">提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog title="68二维码" width="440px" :visible.sync="qrImgDialog">
        <img height="400" width="400" :src="qrImg" />
      </el-dialog>
      <el-dialog title="hz二维码" width="440px" :visible.sync="qrImgDialogHz">
        <qrcode :value="
          qrcodeUrl +
          `/qrcodeHzkt/add?id=` +
          this.classInfoDetail.id +
          `&agentId=` +
          this.classInfoDetail.agentId +
          `&type=0`
        " :options="{ size: 400 }"></qrcode>
      </el-dialog>

      <!-- <el-dialog title="导入学员" :visible.sync="importFormVisible" width="800px" left>
        <el-row style="margin-bottom:10px;" class="importForm">
          <el-col :span="4">
            <el-upload
              class="upload-demo"
              :action="fileAction"
              :on-success="handleSuccess"
              :headers="reqData"
              :file-list="fileList"
            >
              <el-button>上传附件</el-button>
            </el-upload>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="importExcel">下载模板</el-button>
          </el-col>
          <el-col :span="16" style="text-align: right">
           <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
          </el-col>
        </el-row>
        <el-table
          ref="multipleTable"
          :data="importStudentForm.rows"
          tooltip-effect="dark"
          style="margin-top: 22px; width: 100%;"
          border
          @selection-change="selectionChange"
        >
          <el-table-column type="selection" :selectable="checkboxT" width="55"></el-table-column>
          <el-table-column prop="mobile" label="学员手机"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
        </el-table>
      </el-dialog>-->
    </el-card>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { mapGetters } from "vuex";
import moment from "moment";

import VueQrcode from '@xkeshi/vue-qrcode';

export default {
  components: {
    QRCode,
    qrcode: VueQrcode
  },
  data () {
    return {
      subjectNameBlock: false,
      classListLoading: true,
      qrImgDialog: false,
      qrImgDialogHz: false,
      calendarData: [],
      currentDate: new Date(),
      currentWeekDate: [
        moment(new Date())
          .startOf("week")
          .subtract(-1, "days")
          .format("YYYY-MM-DD"),
        moment(new Date())
          .endOf("week")
          .subtract(-1, "days")
          .format("YYYY-MM-DD")
      ],
      classInfoDetailTrue: true,
      studentDialogVisible: false,
      changeCourseDialog: false,
      changeClassDialog: false,
      clickTrue: true,
      importFormVisible: false,
      fileAction: `${process.env.BASE_URL}/student/upload`,
      importStudentForm: {},
      fileList: [],
      classInfoPhaseId: null,
      classInfoPhaseTree: [],
      changeCourseForm: {},
      changeClassForm: {},
      subjectName: null,
      qrImg: null,
      mousemoveShow: "",
      formLabelWidth: "90px",
      value: new Date(),
      courseIds: [],
      subjectTreeList: [],
      classroomList: [],
      classInfoList: [],
      classManageSearch: {
        pageNumber: 1,
        pageSize: 1000,
        subjectCourseId: null,
        classInfoPhase: null
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      campusListProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      campusTreeProp: {
        value: "id",
        label: "name",
        children: "children"
      },
      classInfoDetail: {},
      qrcodeUrl: process.env.CODE_URL,
      ClassInfoTree: [],
      multipleSelection: [],
      studentAllSelection: {
        idList: [],
        classInfoId: ""
      },
      ChapterProps: {
        value: "id",
        children: "children",
        label: "phase"
      },
      subjectProps: {
        value: "id",
        children: "children",
        label: "name"
      },
      activeName: "first",
      calendarActiveName: "month",
      classList: [],
      studentList: {},
      studentAllList: {},
      studentSearch: {},
      classDialogVisible: false,
      editClassDialogVisible: false,
      campusList: [],
      teacherList: [],
      headTeacherList: [],
      academicTeacherList: [],
      signLogList: [],
      searchForm: {
        headTeacher: "",
        courseId: ""
      },
      studentAllSearch: {
        pageNumber: 1,
        pageSize: 10,
        campusIds: [],
        courseIds: [],
        courseId: "",
        period: []
      },
      classInfoOrderInfoSearch: {
        pageNumber: 1,
        pageSize: 1000
        // courseId: "",
        // name: "",
        // courseIds: []
      },
      classDetailList: {},
      addForm: {
        remark: ""
      },
      editForm: {
        period: []
      },
      jump: {},
      changeClassFormRules: {
        campusId: [
          {
            required: true,
            message: "请选择所属校区",
            trigger: "change"
          }
        ],
        courseId: [
          {
            required: true,
            message: "请选择所属科目",
            trigger: "change"
          }
        ],
        classInfoId: [
          {
            required: true,
            message: "请选择所属班级",
            trigger: "change"
          }
        ]
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入班级名称",
            trigger: "blur"
          }
        ],
        campusId: [
          {
            required: true,
            message: "请选择所属校区",
            trigger: "change"
          }
        ],
        subjectCourseId: [
          {
            required: true,
            message: "请选择所属科目",
            trigger: "change"
          }
        ],
        classInfoPhase: [
          {
            required: true,
            message: "请选择班级期数",
            trigger: "change"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择班级类型",
            trigger: "change"
          }
        ],
        headTeacherName: [
          {
            required: true,
            message: "请选择班主任",
            trigger: "change"
          }
        ],
        signDistance: [
          {
            required: true,
            message: "请选择签到距离",
            trigger: "change"
          }
        ],
        maxNumber: [
          {
            required: true,
            message: "请输入开班人数",
            trigger: "blur"
          }
        ],
        period: [
          {
            required: true,
            message: "请选择开班时间",
            trigger: "change"
          }
        ]
        // teacherIds: [
        //   {
        //     required: true,
        //     message: "请选择修改人",
        //     trigger: "change"
        //   }
        // ]
      },
      classNum: {
        minNumber: '',
        maxNumber: ''
      }
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    }
  },
  methods: {
    querySearch (queryString, cb) {
      // console.log(813,queryString);
      this.headTeacherList.forEach(item => {
        if (item.campusName) {
          item.value = item.name + "-" + item.campusName;
        } else {
          item.value = item.name;
        }
      })
      var restaurants = this.headTeacherList
      // console.log(466,restaurants);
      var results = queryString != '' ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // // 调用 callback 返回建议列表的数据

      cb(results);
    },

    createFilter (queryString) {
      return (restaurants) => {
        return restaurants.value == undefined ? false : restaurants.value.indexOf(queryString) !== -1;
      };
    },
    handleSelect (val) {
      // console.log(470,val);
      this.editForm.headTeacher = val.id
    },

    showQrcode () {
      let qrNode = document.getElementById("qrcode");
      this.qrImg = document.getElementById("qrcode").childNodes[1].src;
      this.qrImgDialog = true;
    },
    goStudent (item) {
      this.$router.push({ path: "/classDetailStudent", query: { id: item.id } })
    },
    changingCourse (item) {
      this.changeCourseForm = {};
      this.api.agentUserInfo
        .getTeacherList({ campusId: item.campusId })
        .then(result => {
          if (result.success) {
            this.teacherList = result.data;
            if (this.teacherList.length === 0) {
              this.$message.error("该校区暂无老师，请添加老师信息");
            }
          } else {
            this.$message.error(result.message);
          }
        });
      this.api.classroom
        .getClassroomList({ campusId: item.campusId })
        .then(result => {
          if (result.success) {
            this.classroomList = result.data;
            if (this.classroomList.length === 0) {
              this.$message.error("该校区暂无教室，请添加教室信息");
            }
            this.$set(this.changeCourseForm, "classroomId", item.classroomId);
            this.$set(this.changeCourseForm, "teacherId", item.teacherId);
            this.$set(this.changeCourseForm, "date", item.date);
            this.$set(
              this.changeCourseForm,
              "beginTime",
              item.schedulePeriod.beginTime
            );
            this.$set(
              this.changeCourseForm,
              "endTime",
              item.schedulePeriod.endTime
            );
            this.$set(this.changeCourseForm, "classInfoId", item.classInfoId);
            this.$set(
              this.changeCourseForm,
              "schedulePeriodId",
              item.schedulePeriodId
            );
            this.$set(this.changeCourseForm, "classInfoId", item.classInfoId);
            this.$set(this.changeCourseForm, "id", item.id);
          } else {
            this.$message.error(result.message);
          }
        });
      // this.changeCourseForm.classroomId = item.classroomId;
      // this.changeCourseForm.teacherId = item.teacherId;
      // this.changeCourseForm.date = item.date;
      this.changeCourseDialog = true;
    },
    transferClass () {
      this.api.scheduleInfo
        .transferClass(this.changeCourseForm)
        .then(result => {
          if (result.success) {
            this.changeCourseDialog = false;
            this.classroomCalendar();
          } else {
            this.$message.error(result.message);
          }
        });
    },
    suspendClass (item) {
      this.$confirm("您确定要进行停课操作吗？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.api.scheduleInfo.suspendClass({ id: item.id }).then(result => {
          if (result.success) {
            this.classroomCalendar();
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    resumeClass (item) {
      this.api.scheduleInfo.resumeClass({ id: item.id }).then(result => {
        if (result.success) {
          this.classroomCalendar();
        } else {
          this.$message.error(result.message);
        }
      });
    },

    handleSuccess (response, file, fileList, $event) {
      this.importStudentForm = response.data;
    },
    studentAllSelectionChange (val) {
      // this.studentAllSelection.agentId = JSON.parse(
      //   localStorage.getItem("user")
      // ).agentId;
      // this.studentAllSelection.classInfoId = this.jump.id;
      this.studentAllSelection.idList = [];
      this.studentAllSelection.classInfoId = this.jump.id;
      for (let item of val) {
        this.studentAllSelection.idList.push(item.studentId);
      }
    },
    checkboxT (row, rowIndex) {
      if (row.remark == "") {
        return true;
      } else {
        return false;
      }
    },
    importExcel () {
      window.open(
        "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/student/%E5%AD%A6%E7%94%9F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xls"
      );
    },
    addClassInfoOrderInfo () {
      console.log("studentAllSelection", this.studentAllSelection);
      if (this.studentAllSelection.idList.length == 0) {
        this.$message.error("请选择需要添加的学员");
      } else {
        this.api.classInfoStudent
          .addClassInfoStudent(this.studentAllSelection)
          .then(result => {
            this.$message({
              type: "success",
              message: result.message
            });
            this.activeName = "third";
            this.studentDialogVisible = false;
            this.classInfoOrderInfoPageList();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    goAddClass (row) {
      console.log("row", row)
      let jump = [row];
      localStorage.setItem("classDetail", JSON.stringify(jump));
      this.$router.push({ path: "/addClass" });
    },
    campusIdChange (item) {
      let length = item.length;
      let index = length;
      this.getHeadTeacherList(item[index - 1]);
      this.getAcademicTeacherList(item[index - 1]);
      this.getClassInfoTree(item[index - 1]);
      this.addForm.campusId = item[index - 1];
      this.searchForm.subjectId = null;
      this.classInfoPhaseTree = [];
    },
    getTeacherTreeChange (item) {
      let length = item.length;
      let index = length;
      (this.addForm.headTeacher = ""),
        (this.addForm.teacherIds = []),
        (this.editForm.headTeacher = ""),
        (this.editForm.teacherIds = []),
        (this.addForm.campusId = item[index - 1]);
      this.getHeadTeacherList(item[index - 1]);
      this.getAcademicTeacherList(item[index - 1]);
    },
    //选择添加科目
    subjectIdChange () {
      this.classInfoPhaseTree = [];
      this.searchForm.subjectId = this.searchForm.subjectId[1];
      this.getClassInfoPhaseTree();
      // this.addForm.subjectCourseId = this.addForm.courseIds[2];
      // this.searchForm.courseId = this.searchForm.courseIds[2];
    },
    subjectSearchChange () {
      this.searchForm.subjectCourseId = this.addForm.subjectCourseId[2];
    },
    editSubjectSearchChange () {
      this.searchForm.subjectCourseId = this.editForm.subjectCourseId[2];
    },

    initGetData () {
      this.classInfoPhaseId = this.$route.query.id;
      this.classInfoDetailTrue = false
      this.api.classInfoPhase
        .getClassInfoPhaseDetail({ id: this.$route.query.id })
        .then(result => {
          if (result.success) {
            this.$set(this, 'classInfoDetail', result.data)
            this.subjectNameBlock = true
            this.classInfoDetailTrue = true
            this.$nextTick(function () {
              document.getElementById("qrcode").innerHTML = "";
              this.liveQrcode(this.classInfoDetail.id, this.classInfoDetail.agentId);
            });
            this.getclassInfoList();
            this.searchForm.campusId = this.classInfoDetail.campusId;
            this.searchForm.subjectId = this.classInfoDetail.subjectCourseId;
            this.getTree(this.searchForm.campusId);
          } else {
            this.$message.error(result.message);
          }
        });
    },

    liveQrcode (id, agentId) {

      let that = this;
      let qrcode = new QRCode("qrcode", {
        width: 400,
        height: 400, // 高度
        // text: `https://api.g.68wx.com/qrcode/add?id=${id}&agentId=${agentId}` // 二维码内容 线上版
        // text: `https://test.api.68wx.com/qrcode/add?id=${id}&agentId=${agentId}` // 二维码内容 测试版
        text: `${process.env.CODE_URL}/qrcode/add?id=${id}&agentId=${agentId}&type=0`
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      });
      console.log(qrcode);
    },

    classInfoDetailTrueChange () {
      this.classInfoDetailTrue = true;
      this.$nextTick(function () {
        document.getElementById("qrcode").innerHTML = "";
        this.liveQrcode(this.classInfoDetail.id, this.classInfoDetail.agentId);
      });
    },

    getData (id) {
      this.api.classInfoPhase
        .getClassInfoPhaseDetail({ id: id })
        .then(result => {
          if (result.success) {
            this.classInfoDetail = result.data;
            this.getclassInfoList();
          } else {
            this.$message.error(result.message);
          }
        });
    },
    // getScheduleInfo() {
    //   this.api.classInfo.getScheduleInfo({ id: this.$route.query.id }).then(result => {
    //     if (result.success) {
    //       this.classList = [result.data];
    //     } else {
    //       this.$message.error(result.message);
    //     }
    //   });
    // },
    getclassInfoList () {
      this.classManageSearch.subjectCourseId = this.classInfoDetail.subjectCourseId;
      this.classManageSearch.classInfoPhaseId = this.classInfoDetail.id;
      this.api.classInfo
        .pageList(this.classManageSearch)
        .then(result => {
          this.classList = result.data.records;
          this.classListLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getCampusTree () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          if (result.data.length > 0) {
            // this.searchForm.campusId = result.data[0].id;
            this.searchForm.campusId = this.classInfoDetail.campusId;
            this.getTree(this.searchForm.campusId);
            this.getHeadTeacherList(this.searchForm.campusId);
            this.getAcademicTeacherList(this.searchForm.campusId);
            // this.getTeacherList(this.searchForm.campusId);
          }
          this.addForm.campusId = this.searchForm.campusId;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeGetClassInfo (id) {
      // this.changeClassForm.classInfoId = "";
      this.$set(this.changeClassForm, "classInfoId", "");
      let index = 0;
      if (id.length > 0) {
        index = id.length;
      }
      console.log("index", index);
      this.api.classInfo
        .getClassInfoList({ campusId: id[index - 1] })
        .then(result => {
          if (result.success) {
            this.classInfoList = result.data;
            if (this.classInfoList.length == 0) {
              this.$message.error("该校区暂无班级");
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getClassInfoList (id) {
      this.api.classInfo
        .getClassInfoList({ campusId: id })
        .then(result => {
          if (result.success) {
            this.classInfoList = result.data;
            this.changeClassDialog = true;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //签到距离
    // getSignLogList() {
    //   this.api.signLog.getSignLogList().then(result => {
    //     if (result.success) {
    //       this.signLogList = result.data;
    //     } else {
    //       this.$message.error(result.message);
    //     }
    //   });
    // },

    //获取班主任列表
    getHeadTeacherList (id) {
      // this.api.agentUserInfo
      //   .getHeadTeacherList({ campusId: id })
      //   .then(result => {
      //     if (result.success) {
      //       this.headTeacherList = result.data;
      //     } else {
      //       this.$message.error(result.message);
      //     }
      //   });
      this.api.agentUserInfo.getTeacherListInfo().then(result => {
        if (result.success) {
          this.headTeacherList = result.data;
        } else {
          this.$message.error(result.message);
        }
      })
    },

    //获取教务老师列表
    getAcademicTeacherList (id) {
      this.api.agentUserInfo
        .getAcademicTeacherList({ campusId: id })
        .then(result => {
          if (result.success) {
            this.academicTeacherList = result.data;
          } else {
            this.$message.error(result.message);
          }
        });
    },

    //获取老师列表
    getTeacherList (id) {
      this.api.agentUserInfo.getTeacherList({ campusId: id }).then(result => {
        if (result.success) {
          this.teacherList = result.data;
          if (this.teacherList.length === 0) {
            this.$message.error("该校区暂无老师，请添加老师信息");
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    //获取教室列表
    getClassroomList (id) {
      this.api.classroom.getClassroomList({ campusId: id }).then(result => {
        if (result.success) {
          this.classroomList = result.data;
          if (this.classroomList.length === 0) {
            this.$message.error("该校区暂无教室，请添加教室信息");
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },

    // 获取课程
    getSubjectTreeList () {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    //获取课程树
    getTree (id) {
      this.api.subjectCourse
        .getSubjectTreeList(id)
        .then(result => {
          if (result.success) {
            for (let item of result.data) {
              if (item.children.length != 0) {
                for (let items of item.children) {
                  delete items.children;
                }
              } else {
                // delete item.children;
              }
            }
            this.ClassInfoTree = result.data;
            if (this.ClassInfoTree.length > 0) {
              this.searchForm.subjectId = this.classInfoDetail.subjectCourseId;
              this.subjectName = this.classInfoDetail.subjectName;
              this.getClassInfoPhaseTree();
            } else {
              this.activeName = "first";
              this.$message.error("暂无班级，请创建新的班级");
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取课程树
    getClassInfoTree (id) {
      this.api.subjectCourse
        .getClassInfoTree(id)
        .then(result => {
          if (result.success) {
            this.ClassInfoTree = result.data;
            if (this.ClassInfoTree.length > 0) {
            } else {
              this.$message.error("暂无班级，请创建新的班级");
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    getClassInfoPhaseTree () {
      this.api.classInfoPhase
        .getClassInfoPhaseTree({
          campusId: this.searchForm.campusId,
          subjectCourseId: this.searchForm.subjectId
        })
        .then(result => {
          if (result.success) {
            this.classInfoPhaseTree = result.data;
            this.$nextTick(function () {
              this.$refs.tree.setCurrentKey(this.$route.query.id);
            });
          } else {
            this.$message.error(result.message);
          }
        });
    },

    handleNodeClick (data) {
      this.classInfoPhaseId = data.id;
      this.getData(data.id);
      // if (this.clickTrue == true) {
      //   this.searchForm.courseId = data.id;
      //   if (level === 4) {
      //     localStorage.setItem("jump", JSON.stringify(data));
      //     this.activeName = "first";
      //     this.getData();
      //   }
      // } else {
      // }
    },

    studentAllPageList () {
      if (typeof this.studentAllSearch.courseIds == "object") {
        let index = this.studentAllSearch.courseIds.length;
        this.studentAllSearch.courseId = this.studentAllSearch.courseIds[
          index - 1
        ];
      }
      if (typeof this.studentAllSearch.campusIds == "object") {
        let index = this.studentAllSearch.campusIds.length;
        this.studentAllSearch.campusId = this.studentAllSearch.campusIds[
          index - 1
        ];
      }
      if (this.studentAllSearch.period) {
        if (this.studentAllSearch.period.length > 0) {
          this.studentAllSearch.beginDate = this.studentAllSearch.period[0];
          this.studentAllSearch.endDate = this.studentAllSearch.period[1];
        }
      }
      this.api.studentCourse
        .studentPageList(this.studentAllSearch)
        .then(result => {
          this.studentAllList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
      // this.api.classInfoOrderInfo
      //   .pageList(this.studentAllSearch)
      //   .then(result => {
      //     this.studentAllList = result.data;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },
    updateStudentCourse () {
      this.api.studentCourse
        .updateStudentCourse()
        .then(result => {
          // this.studentAllList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeClass (row) {
      console.log("row", row);
      this.$set(this.changeClassForm, "campusId", row.campusId);
      this.getSubjectTreeList();
      this.getCampusList();
      this.getClassInfoList(row.campusId);
      this.$set(this.changeClassForm, "courseId", row.courseId);
      this.$set(this.changeClassForm, "classInfoId", row.classInfoId);
      this.$set(this.changeClassForm, "id", row.id);
      // this.changeClassDialog = true;
    },
    transferClassInfo () {
      this.$refs.changeClassForm.validate(valid => {
        if (valid) {
          if (typeof this.changeClassForm == "object") {
            let index = this.changeClassForm.campusId.length;
            this.changeClassForm.campusId = this.changeClassForm.campusId[
              index - 1
            ];
          }
          if (typeof this.changeClassForm == "object") {
            this.changeClassForm.courseId = this.changeClassForm.courseId[2];
          }
          this.api.classInfoStudent
            .transferClass(this.changeClassForm)
            .then(result => {
              this.changeClassDialog = false;
              this.classInfoOrderInfoPageList();
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    removeStudent (row) {
      this.$confirm("将会移除此学员，是否确认移除？", "系统消息", {
        type: "warning"
      }).then(() => {
        let obj = { id: row.id };
        this.api.classInfoStudent
          .removeClassInfoStudent([obj])
          .then(result => {
            this.classInfoOrderInfoPageList();
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    exportExcel () {
      this.api.studentCourse
        .exportExcel({ classInfoId: this.jump.id })
        .then(result => {
          if (result.success) {
            location.href = result.data;
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    classInfoOrderInfoPageList () {
      // if (this.classInfoOrderInfoSearch.courseIds.length > 0) {
      //   this.classInfoOrderInfoSearch.courseId = this.classInfoOrderInfoSearch.courseIds[2];
      // } else {
      //   this.classInfoOrderInfoSearch.courseId = "";
      // }
      this.classInfoOrderInfoSearch.classInfoId = this.jump.id;
      this.api.classInfoStudent
        .pageList(this.classInfoOrderInfoSearch)
        .then(result => {
          this.studentList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    //添加班级
    addClassInfo () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addForm.subjectCourseId = this.addForm.subjectCourseId[2];
          if (this.addForm.signDistance == '无签到要求') {
            this.addForm.signDistance = -1
          }
          this.addForm.signDistance = Number(this.addForm.signDistance);
          this.api.classInfo.addClassInfo(this.addForm).then(result => {
            if (result.success) {
              this.classDialogVisible = false;
              this.$message.success(result.message);
              this.getCampusTree();
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    //更新班级
    updateClassInfo () {
      this.$refs.editForm.validate(valid => {
        // console.log(1547,this.editForm);
        if (valid) {
          if (typeof this.editForm.campusId == "object") {
            this.editForm.campusId = this.editForm.campusId[2];
          }
          if (typeof this.editForm.subjectCourseId == "object") {
            this.editForm.subjectCourseId = this.editForm.subjectCourseId[1];
          }
          if (this.editForm.signDistance == '无签到要求') {
            this.editForm.signDistance = -1
          }
          this.editForm.signDistance = Number(this.editForm.signDistance);
          this.api.classInfoPhase.updateClassInfoPhase(this.editForm).then(result => {
            if (result.success) {
              this.editClassDialogVisible = false;
              this.$message.success(result.message);
              this.getData(this.classInfoPhaseId);
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },

    editClassInfo () {

      this.editForm = JSON.parse(JSON.stringify(this.classInfoDetail));
      // this.editForm=this.classInfoDetail
      if (this.editForm.signDistance == -1) {
        this.editForm.signDistance = '无签到要求'
      }
      this.getHeadTeacherList(this.editForm.campusId);
      this.getAcademicTeacherList(this.editForm.campusId);
      this.editForm.classInfoPhase = this.editForm.phase;
      // this.classNum.maxNumber=JSON.parse(JSON.stringify(this.classInfoDetail)).maxNumber
      // this.classNum.minNumber=JSON.parse(JSON.stringify(this.classInfoDetail)).minNumber
      // this.editForm.period = [this.editForm.startDate,this.editForm.endDate];
      this.$set(this.editForm, 'period', [this.editForm.startDate, this.editForm.endDate])
      this.editClassDialogVisible = true;

      // this.classInfoDetail = JSON.parse(JSON.stringify(this.editForm));
      // this.api.classInfo.checkPermission({ id: this.$route.query.id }).then(res => {
      //   if (res.success) {
      //     this.api.classInfo
      //       .getClassInfo({
      //         id: this.jump.id
      //       })
      //       .then(result => {
      //         if (result.success) {
      //           this.editForm = result.data;
      //           this.editForm.period = [
      //             this.editForm.startDate,
      //             this.editForm.endDate
      //           ];
      //           this.getHeadTeacherList(this.editForm.campusId);
      //           this.getAcademicTeacherList(this.editForm.campusId);
      //           this.editClassDialogVisible = true;
      //         } else {
      //           this.$message.error(result.message);
      //         }
      //       });
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },

    deleteClassInfo () {
      this.$confirm("将会删除此班级，是否确认删除？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.api.classInfoPhase
          .deleteClassInfoPhase([{ id: this.classInfoPhaseId }])
          .then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.$router.push({ path: "/classManage" });
            } else {
              this.$message.error(result.message);
            }
          });
      });
    },
    addCourse () {
      this.classDialogVisible = true;
      this.clickTrue = true;
    },

    calendarHandleClick (tab, event) {
      if (tab.name === "week") {
        this.classroomCalendar(
          this.currentWeekDate[0],
          this.currentWeekDate[1]
        );
      }
      if (tab.name === "month") {
        this.classroomCalendar();
      }
    },
    //获取日历课程
    classroomCalendar (beginDate, endDate) {
      console.log("classList", this.classList);
      let ids = [];
      this.classList.forEach(res => {
        ids.push(res.id)
      })
      let obj = {};
      if (beginDate) {
        obj = {
          // classInfoIds: [this.$route.query.id],
          classInfoIds: ids,
          beginDate: beginDate,
          endDate: endDate
        };
      } else {
        obj = {
          classInfoIds: ids,
          beginDate: moment()
            .month(moment().month())
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment()
            .month(moment().month())
            .endOf("month")
            .format("YYYY-MM-DD")
        };
      }
      this.api.classInfo.scheduleCalendar(obj).then(result => {
        if (result.success) {
          this.calendarData = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    lastWeek () {
      this.currentWeekDate = [
        moment(this.currentWeekDate[0])
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
        moment(this.currentWeekDate[1])
          .subtract(7, "days")
          .format("YYYY-MM-DD")
      ];
      this.classroomCalendar(this.currentWeekDate[0], this.currentWeekDate[1]);
    },
    nextWeek () {
      this.currentWeekDate = [
        moment(this.currentWeekDate[0])
          .subtract(-7, "days")
          .format("YYYY-MM-DD"),
        moment(this.currentWeekDate[1])
          .subtract(-7, "days")
          .format("YYYY-MM-DD")
      ];
      this.classroomCalendar(this.currentWeekDate[0], this.currentWeekDate[1]);
    },
    nowWeek () {
      this.currentWeekDate = [
        moment(this.nowTime)
          .startOf("week")
          .subtract(-1, "days")
          .format("YYYY-MM-DD"),
        moment(this.nowTime)
          .endOf("week")
          .subtract(-1, "days")
          .format("YYYY-MM-DD")
      ];
      this.classroomCalendar(this.currentWeekDate[0], this.currentWeekDate[1]);
    },

    handleClick (tab, event) {
      if (tab.name == "first") {
        this.getScheduleInfo();
      }
      if (tab.name == "second") {
        this.classroomCalendar();
      }
      if (tab.name == "third") {
        this.classInfoOrderInfoPageList();
      }
    },
    // studentListSizeChange(pageSize) {
    //   this.classInfoOrderInfoSearch.pageSize = pageSize;
    //   this.classInfoOrderInfoPageList();
    // },
    // studentListCurrentChange(pageNumber) {
    //   this.classInfoOrderInfoSearch.pageNumber = pageNumber;
    //   this.classInfoOrderInfoPageList();
    // },
    studentAllSizeChange (pageSize) {
      this.studentAllSearch.pageSize = pageSize;
      this.studentAllPageList();
    },
    studentAllCurrentChange (pageNumber) {
      this.studentAllSearch.pageNumber = pageNumber;
      this.studentAllPageList();
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    }
  },
  watch: {
    currentDate (nVal) {
      let beginDate = moment(this.currentDate)
        .startOf("month")
        .format("YYYY-MM-DD");
      let endDate = moment(this.currentDate)
        .endOf("month")
        .format("YYYY-MM-DD");
      this.classroomCalendar(beginDate, endDate);
    },
    classDialogVisible (val) {
      if (!val) {
        this.$refs.addForm.resetFields();
        this.addForm.minNumber = null;
        this.addForm.maxNumber = null;
        this.addForm.remark = "";
      }
    },
    editClassDialogVisible (val) {
      if (!val) {
        this.$refs.editForm.resetFields();
        this.editForm.minNumber = null;
        this.editForm.maxNumber = null;
        this.editForm.remark = "";
      }
    }
  },
  mounted () {
  },
  created () {
    // this.getCampusTree();
    this.getCampusList();
    this.initGetData();
    this.getSubjectTreeList();
  }
};
</script>
<style lang="less">
.classDetail {
  background-color: #fff;
}

.classDetail-left {
  width: 20%;
  justify-content: flex-start;
  border-right: 1px solid rgba(238, 238, 238, 1);
}

.classDetail-right {
  width: 80%;
  padding: 20px;
}

.tab-type {
  /* padding: 20px; */
  /* padding-top: 10px; */
}

.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}

.left-top {
  padding: 0px 20px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 40px;
  line-height: 40px;
}

.left-top-text {
  float: left;
}

.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
}

.classDetail-search {
  padding: 0px 20px;
}

.classDetail-select {
  width: 100%;
  margin-top: 20px;
}

.classDetail-top {
  background-color: rgba(246, 249, 250, 1);
  padding: 20px 20px 10px 20px;
}

.classDetail-top-qrcode {
  border: 1px solid #ccc;
  padding: 5px;
  width: 80px !important;
  cursor: pointer;

  canvas {
    height: 80px !important;
    width: 80px !important;
  }

  img {
    height: 80px !important;
    width: 80px !important;
  }
}

.classDetail-right-top {
  display: flex;
  padding-bottom: 10px;
}

.right-top-type1 {
  height: 20px;
  width: 50px;
  background-color: #ffc349;
  line-height: 20px;
  text-align: center;
  color: #fff;
  margin-left: 20px;
}

.right-top-type2 {
  height: 20px;
  width: 50px;
  background-color: #24d2b5;
  line-height: 20px;
  text-align: center;
  color: #fff;
  margin-left: 20px;
}

.right-top-type3 {
  height: 20px;
  width: 50px;
  background-color: #a2aabc;
  line-height: 20px;
  text-align: center;
  color: #fff;
  margin-left: 20px;
}

.right-top-text {
  font-size: 16px;
  font-weight: 700;
}

.basicInformation {
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 20px;
  font-size: 13px;
}

.classInformation {
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 20px;
  font-size: 13px;
  margin-top: 20px;
}

.classDetail-icon {
  float: right;
  font-size: 16px;
  margin-left: 20px;
  color: #a2aabc;
  cursor: pointer;
}

.classDetail-icon:hover {
  color: #4d94ff;
}

.classDetail-study0 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #4d94ff;
  margin-top: 2px;
  border-left: 2px solid rgba(77, 148, 255, 1);
  background-color: rgba(36, 210, 181, 0.0980392156862745);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.classDetail-study1 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #24d2b5;
  margin-top: 2px;
  border-left: 2px solid #24d2b5;
  background-color: rgba(36, 210, 181, 0.0980392156862745);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.classDetail-study2 {
  display: flex;
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #ffc349;
  margin-top: 2px;
  border-left: 2px solid #ffc349;
  background-color: rgba(255, 195, 73, 0.0980392156862745);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.classDetail-study3 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #ff5555;
  margin-top: 2px;
  border-left: 2px solid #ff5555;
  background-color: rgba(255, 85, 85, 0.0980392156862745);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.classDetail-study4 {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #455a64;
  margin-top: 2px;
  border-left: 2px solid #a2aabc;
  background-color: rgba(162, 170, 188, 0.0980392156862745);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tree-class1 {
  background-color: #ffc349;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}

.tree-class2 {
  background-color: rgba(36, 210, 181, 1);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}

.tree-class3 {
  background-color: #a2aabc;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}

.classDetail-classList {
  margin-top: 20px;
  margin-bottom: 20px;
}

.courseManage {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}

.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}

.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}

.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}

.calendar-solt1 {
  font-size: 16px;
  color: #455a64;
  font-weight: 600;
  width: 200px;
}

.calendar-solt2 {
  font-size: 13px;
  margin-top: 10px;
}

.calendar-solt3 {
  border-top: 1px solid #e4e7ed;
  margin-top: 10px;
}

.time-selectType {
  text-align: center;
  width: 100%;
  line-height: 40px;
}

.rowStyle1 {
  width: 14px;
  height: 14px;
  border-radius: 0px;
  background-color: #4d94ff;
  margin-left: 0px;
  margin-top: 10px;
}

.rowStyle2 {
  width: 14px;
  height: 14px;
  border-radius: 0px;
  background-color: #24d2b5;
  margin-left: 20px;
  margin-top: 10px;
}

.rowStyle3 {
  width: 14px;
  height: 14px;
  background-color: #ffc349;
  border-radius: 0px;
  margin-left: 20px;
  margin-top: 10px;
}

.rowStyle3-text {
  line-height: 15px;
  margin-left: 5px;
  margin-top: 10px;
}

.rowStyle4 {
  width: 14px;
  height: 14px;
  border-radius: 0px;
  background-color: #ff5555;
  margin-left: 20px;
  margin-top: 10px;
}

.rowStyle5 {
  width: 14px;
  height: 14px;
  background-color: #a2aabc;
  border-radius: 0px;
  margin-left: 20px;
  margin-top: 10px;
}

.calendar-button {
  float: right;
}

.calendar-button1 {
  height: 28px;
  line-height: 10px;
}

.rowStyle6 {
  width: 20px;
  height: 20px;
  background-color: rgba(36, 210, 181, 1);
  border-radius: 50%;
  margin: auto;
}

.rowStyle7 {
  width: 20px;
  height: 20px;
  background-color: rgba(255, 85, 85, 1);
  border-radius: 50%;
  margin: auto;
}

.rowStyle8 {
  width: 15px;
  height: 15px;
  background-color: rgba(36, 210, 181, 1);
  border-radius: 50%;
  margin-top: 4px;
}

.rowStyle9 {
  width: 15px;
  height: 15px;
  background-color: rgba(255, 85, 85, 1);
  border-radius: 50%;
  margin-top: 4px;
}
</style>
<style lang="less">
.classDetail {
  .el-calendar-table .el-calendar-day {
    height: 150px;
  }

  .el-card__body {
    padding: 0px;
  }

  .flex {
    display: flex;

    .el-card__body {
      padding: 0px !important;
    }

    .el-form-item {
      margin-bottom: 0px;
    }

    .el-form-item__label {
      line-height: 30px;
      font-size: 13px !important;
      font-weight: 400;
      color: #455a64;
    }

    .el-form-item__content {
      line-height: 30px;
      font-size: 13px !important;
    }

    .el-tabs__nav {
      margin-left: 20px;
    }

    .calendarType {
      .el-tabs__nav {
        margin-left: 0px !important;
      }
    }

    .classDetail-tree {
      margin-top: 10px;

      .el-tree-node__label {
        font-size: 13px;
        color: #a2aabc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classManage/classDetail.vue